import { EscolaApi } from "~/api/escola/escola";
import type { Escola } from "~/types/schemas/escola"

interface EscolaState {
  escola_id: string | number | null;
  escola: Escola | null;
}

export const useEscolaStore = defineStore('escola', {
  state: (): EscolaState => ({
    escola_id: null,
    escola: null,
  }),
  persist: {
    storage: sessionStorage,
    pick: ['escola_id', 'escola'],
  },
  getters: {
    async escolas(): Promise<Escola[]> {
      const { data } = await EscolaApi.find({ query: { ativo: true } });
      return data;
    },
  },
  actions: {
    setEscola(escola: Escola | null): void {
      this.escola_id = escola?.id || null;
      this.escola = escola;
    },
    resetEscola(): void {
      this.escola_id = null;
      this.escola = null;
    },
  }
})
